import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../lib/auth';

interface PublicRouteProps {
  children: React.ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const user = getCurrentUser();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  // If user is already logged in, redirect to dashboard
  if (user) {
    // Redirect to dashboard or the page they were trying to access
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}